import React from 'react';
import Info from '../../../SvgIcons/Info';
import { Tooltip, TooltipContainer } from './FormTooltip.styles';

export interface FormTooltipProps {
  text?: React.ReactNode;
  className?: string;
}

const FormTooltip: React.FC<FormTooltipProps> = ({ text, className }): JSX.Element => (
  <TooltipContainer className={className}>
    <Info width={14} height={14} title="info-icon" />
    <Tooltip>{text}</Tooltip>
  </TooltipContainer>
);

export default FormTooltip;
